module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAMCAYAAABbayygAAAAbElEQVQoU9WR0QmAMAxEX6HO5AQiqFM5kwrS0RSUKw3EIv7br5R7JLlL4P1dQPDS4+OEX4MROD/MRLmegRYYHexdq8kqMBeAxKnABkpblKnlWMMH0BikaT5wD/fAXq6TV6ovI3gDOiABg+19A1rlG4e2QFekAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/download-icon.png
// module id = Yo2E
// module chunks = 2